<template>
<div id="app">
  <b-navbar>
    <div class="container">
      <b-navbar-brand :to="{name:'Home'}">C-Suite Community</b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <member-search></member-search>
        <b-navbar-nav class="ml-auto">
          <!-- <b-nav-item-dropdown text="Members">
            <hr>
          </b-nav-item-dropdown> -->
          <b-nav-item :to="{name:'Insights'}">Insights</b-nav-item>
          <b-nav-item :to="{name:'PriorityQueue'}">Priority Queue</b-nav-item>
          <b-nav-item :to="{name:'BacklogQueue'}">Backlog</b-nav-item>
          <b-nav-item :to="{name:'MemberList'}">All Members</b-nav-item>
          <!-- <b-nav-item :to="{name:'SMSInbox'}">Inbox</b-nav-item> -->
          <!-- <b-nav-item>{{user.name}}</b-nav-item> -->
          <b-nav-item-dropdown right>
            <template #button-content>
              <b-avatar variant="success" size="sm" :text="initials"></b-avatar>
            </template>
          </b-nav-item-dropdown>

          <!-- <b-button variant="light" @click="nextInQueue()">Next Call</b-button> -->
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
  <app-phone></app-phone>
  <router-view class="main" />
</div>
</template>
<script>
import $auth from '@/services/auth';
import $queue from '@/services/queue';
import $notifications from '@/services/notifications';
import AppPhone from '@/components/global/AppPhone';
import MemberSearch from '@/components/members/MemberSearch';
import {ListMembers} from '@/gql/members/Members.gql';

export default {
  components: {
    AppPhone,
    MemberSearch
  },
  data() {
    return {
      user: $auth.getUser()
    }
  },
  computed: {
    initials() {
      return $auth.getUser().name.split(' ').map(w => w.substring(0,1)).join('');
    },
  },
  methods: {
    async nextInQueue() {
      let data = await $queue.listMembers(10, 0);
      const people = data.filter(person => {
        return (person.actionable)
        && (person.id != this.$router.currentRoute.params.id)
      });
      if(people.length > 0){
        let person = people[Math.floor(Math.random() * people.length)];
        this.$router.push({
          name: 'MemberDetail',
          params: person
        });
      }
      else{
        alert('No available people');
      }
    }
  },
  created() {
    $notifications.init();
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.simple-link
{
  color:inherit;
}
</style>
